export default __webpack_public_path__ + "static/php-web-development-company-peerbits-3abc878d08e48f7d8ea3e12cfd144cce.png";